import { render, staticRenderFns } from "./yinsixieyi.vue?vue&type=template&id=27483245&scoped=true&"
import script from "./yinsixieyi.vue?vue&type=script&lang=js&"
export * from "./yinsixieyi.vue?vue&type=script&lang=js&"
import style0 from "./yinsixieyi.vue?vue&type=style&index=0&id=27483245&scoped=true&lang=scss&"
import style1 from "./yinsixieyi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27483245",
  null
  
)

export default component.exports